import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1385">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1386">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1387">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1388">
          {isOpen ? <XIcon size={24} data-id="element-1389" /> : <PlusIcon size={24} data-id="element-1390" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1391">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1392">
          {answer}
        </p>
      </div>
    </div>;
}
export function HLFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'How Does Halo Skin Resurfacing Work?',
    answer: 'The Halo laser combines ablative and non-ablative wavelengths to address a wide range of skin concerns, including fine lines, wrinkles, sun damage, and uneven texture. It works by precisely targeting damaged skin cells while stimulating collagen production to promote smoother, more youthful-looking skin.'
  }, {
    question: 'What Cosmetic Concerns Can It Treat?',
    answer: 'Halo is effective for improving the appearance of fine lines, wrinkles, sun damage, uneven skin tone and texture, enlarged pores, and mild to moderate acne scars. It can be used on the face, neck, chest, and other areas of the body to rejuvenate the skin.'
  }, {
    question: 'Is Laser Skin Resurfacing Painful?',
    answer: 'While discomfort levels may vary depending on individual pain tolerance and the intensity of the treatment, most patients report feeling minimal discomfort during the procedure. Topical numbing cream is applied before the treatment to help minimize any discomfort, and the built-in cooling technology of the Halo device further enhances patient comfort.'
  }, {
    question: 'How Many Treatments Are Needed?',
    answer: 'Many patients see noticeable improvement in their skin after just one Halo treatment, with optimal results typically achieved after a series of treatments spaced several weeks apart. At Be CLINICAL, we will assess your skin during your consultation and recommend a personalized treatment plan based on your goals.'
  }, {
    question: 'How Long Is Downtime After A Session?',
    answer: 'Downtime after Halo treatment can vary depending on the intensity of the treatment and individual skin response. Patients may experience redness, swelling, and peeling in the days following the procedure, similar to a moderate sunburn. However, most patients are able to resume their normal activities within a few days to a week with proper post-treatment care.'
  }];
  return <section className="bg-[#ECECEC] pt-[30px] pb-[60px] lg:pt-[60px] lg:pb-[100px]" data-id="element-1393">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1394">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1395">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1396">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1397"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1398">
          <div className="space-y-2" data-id="element-1399">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1400" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}